<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import YTTagsState from "@/components/YTTagsState/index.vue"
import router from "@/router/index.js";
import {tagsStateEnum} from "@/enum/tagsStateEnum.js";
import {addTagGroups, editTagGroupState, tagGroupsList} from "@/api/tagGroup/tagGroup.js";
/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  tagGroupName: null,
  state: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    let param = {
      tagGroupName: formData.tagGroupName,
      state: formData.state === null ? null : formData.state,
    }
    console.log("param", param)
    loading.value = true
    const res = await tagGroupsList(page, param)
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.tagGroupName = null
  formData.state = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '序号', key: 'order', nowrap: true },
  { title: '分组名称', key: 'tagGroupName', nowrap: true },
  { title: '标签数量', key: 'tagCount', nowrap: true },
  { title: '状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', width: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

// 是否为禁用状态
const isDisabled = ref(false)
// 是否为启用状态
const isEnabled = ref(false)
// 处理编辑分组
const handleEdit = (item) => {
  router.push({
    path: "/editTagGroups",
    query: {
      tagGroupId: item.tagGroupId
    }
  })
}
// 处理启用/禁用
const handleState = (item, type) => {
  dialogForm.tagGroupId = item.tagGroupId
  dialogForm.tagGroupName = item.tagGroupName
  dialogForm.tagGroupNameEn = item.tagGroupNameEn
  if (type === "enable") {
    isEnabled.value = true
    open.value = true
    dialogRules.value = rulesThree
  } else {
    isDisabled.value = true
    open.value = true
    dialogRules.value = rulesThree
  }
}

// 处理添加新分组
const handleAdd = () => {
  open.value = true
  dialogRules.value = rulesOne
  dialogFormRef.value.clearValidate()
}

// 分组状态枚举
const tagsState = ref(tagsStateEnum)

// 分组名称校验规则
const checkGroupName = (rule, value, callback) => {
  if (!dialogForm.tagGroupName) {
    return callback(new Error("分组名称（中文）不能为空！"))
  }
  if (!dialogForm.tagGroupNameEn) {
    return callback(new Error("分组名称（English）不能为空！"))
  }
  return callback()
}
// 分组名称校验规则
const checkGroupNameChange = (rule, value, callback) => {
  if (!dialogForm.tagGroupNameChange) {
    return callback(new Error("分组名称（中文）不能为空！"))
  }
  if (!dialogForm.tagGroupNameEnChange) {
    return callback(new Error("分组名称（English）不能为空！"))
  }
  return callback()
}
/*弹窗相关*/
// 弹窗表单锚点
const dialogFormRef = ref()
// 弹窗表单
const dialogForm = reactive({
  tagGroupId: null,
  tagGroupName: null,
  tagGroupNameEn: null,
  tagGroupNameChange: null,
  tagGroupNameEnChange: null,
  applicationReason: null,
})
// 创建分组表单校验规则
const rulesOne = {
  tagGroupName: [
    {required: true, validator: checkGroupName, trigger: "blur"}
  ]
}
// 禁用表单校验规则
const rulesThree = {
  applicationReason: [
    {required: true, message: "请填写原因", trigger: "blur"}
  ]
}
// 弹窗表单校验规则
const dialogRules = ref(rulesOne)
// 关闭新增分组弹窗表单
const closeDialog = () => {
  open.value = false
  dialogForm.tagGroupId = null
  dialogForm.tagGroupName = null
  dialogForm.tagGroupNameEn = null
  dialogForm.tagGroupNameChange = null
  dialogForm.tagGroupNameEnChange = null
  dialogForm.applicationReason = null
  groupNameTab.value = "zh"
  isDisabled.value = false
  isEnabled.value = false
  dialogFormRef.value.clearValidate()
}
// 提交新增分组表单
const submitDialog = async () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        loading.value = true
        if (isEnabled.value) {
          // 启用
          let param = {
            tagGroupId: dialogForm.tagGroupId,
            state: 1,
            applicationReason: dialogForm.applicationReason
          }
          await editTagGroupState(param)
          ElMessage.success("启用申请提交成功")
        } else if (isDisabled.value) {
          // 禁用
          let param = {
            tagGroupId: dialogForm.tagGroupId,
            state: 0,
            applicationReason: dialogForm.applicationReason
          }
          await editTagGroupState(param)
          ElMessage.success("禁用申请提交成功")
        } else if (!isDisabled.value && !isEnabled.value) {
          let param = {
            tagGroupName: dialogForm.tagGroupName,
            tagGroupNameEn: dialogForm.tagGroupNameEn
          }
          await addTagGroups(param)
          ElMessage.success("新增成功")
        }
        closeDialog()
        await handleSearch()
        loading.value = false
      } catch (e) {
        console.log(e)
        loading.value = false
      }
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
      })
    }
  })
}
// 创建分组弹窗打开状态
const open = ref(false)
/*中英文切换输入框相关Tab*/
// 商品分组组tab
const groupNameTab = ref("zh")
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">
        <template v-slot:default>
          <div class="flex_bt">
            <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
            />
            <span>标签分组</span>
          </div>
        </template>
      </v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="1.5">
                    <v-text-field
                        v-model="formData.tagGroupName"
                        placeholder="请输入分组名称"
                        label="分组名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1.5">
                    <v-select
                        v-model="formData.state"
                        placeholder="选择标签状态"
                        variant="outlined"
                        label="标签状态"
                        clearable
                        :items="tagsState"
                        item-title="stateName"
                        item-value="stateId"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('any', 'memberLevelLog:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('any', 'memberLevelLog:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.order=" { item, index } ">
            {{index + 1}}
          </template>

          <template v-slot:item.crUserName=" { item } ">
            {{item.type === 'SYSTEM' ? 'System' : item.crUserName}}
          </template>

          <template v-slot:item.state="{ item }">
            <YTTagsState :state="item.state"></YTTagsState>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon v-if="item.state === 1 || item.state === 3" class="mg_r_1 cursor-pointer" icon="mdi-file-edit-outline" color="primary" size="small" @click="handleEdit(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="启用"
                  placement="top">
                <v-icon v-if="item.state === 0" class="mg_r_1 cursor-pointer" icon="mdi-arrow-up-thin-circle-outline" color="success" @click="handleState(item, 'enable')"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="禁用"
                  placement="top">
                <v-icon v-if="item.state === 1" class="mg_r_1 cursor-pointer" icon="mdi-circle-off-outline" color="error" @click="handleState(item, 'disabled')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <el-dialog
      v-model="open"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">{{isDisabled ? '禁用' : isEnabled ? '启用' :'新增'}}分组</div>
    </template>
    <el-form
        ref="dialogFormRef"
        style="max-width: 100%;"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="loading"
        id="dialogForm"
    >
      <div class="mg_b_2" v-if="isDisabled" style="text-align: left">
        分组名称：{{dialogForm.tagGroupName}}
      </div>
      <el-form-item label="分组名称：" prop="tagGroupName" v-if="!isDisabled && !isEnabled">
        <el-tabs
            v-model="groupNameTab"
            type="card"
            class="demo-tabs"
        >
          <el-tab-pane label="中文" name="zh">
            <el-input show-word-limit maxlength="12" v-model="dialogForm.tagGroupName" placeholder="请勿超过12个字符"></el-input>
          </el-tab-pane>
          <el-tab-pane label="English" name="en">
            <el-input show-word-limit maxlength="40" v-model="dialogForm.tagGroupNameEn" placeholder="Do not exceed 40 characters"></el-input>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item label="申请原因：" prop="applicationReason" v-if="isDisabled || isEnabled">
        <el-input show-word-limit maxlength="20" v-model="dialogForm.applicationReason" placeholder="请填写原因，20个字符内"></el-input>
      </el-form-item>
      <div v-if="isDisabled" style="text-align: left">
        您正在提交禁用分组申请，请填写原因，并复核后再提交。
      </div>
      <div v-if="isEnabled" style="text-align: left">
        您正在提交启用分组申请，请填写原因，并复核后再提交。
      </div>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog">提交</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
